
          import * as Typography from 'components/post/typography'
          export default {
            ...Typography
          }
        